import { render, staticRenderFns } from "./403.vue?vue&type=template&id=5b61d9ac&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "403.vue"
export default component.exports